import { defineStore } from 'pinia'
// import dayjs from 'dayjs'

export const useFiltersCargueFacturasStore = defineStore({
  id: 'filtersCargueFacturas',
  state: () => ({
    _filters: {
      tipoFecha: '',
      fechaInicial: '',
      fechaFinal: '',
      NumAtCard: '',
      proveedor: ''
    },
    _refrescarListadoCargueFacturas: false
  }),
  getters: {
    getFilters: (state) => state._filters,
    getRefrescarListadoCargueFacturas: (state) => state._refrescarListadoCargueFacturas
  },
  actions: {
    setUpdateFilters (filters) {
      this._filters = filters
    },
    setRefrescarListadoCargueFacturas (payload) {
      this._refrescarListadoCargueFacturas = payload
    }
  }
})
